export const ROUTE_CHANGE_ERROR = 'routeChange aborted. Ignore this error.';
